import React from 'react';
import { formatDateToDayMonthYear, useT } from '@repo/common';

const FaqHeader = ({ lastUpdated }) => {
  const t = useT();
  return (
    <div className='flex flex-col items-center w-full typo-h4 text-text-primary gap-2 p-20 pb-0'>
      FAQ
      <div className='typo-b16 text-text-secondary'>
        {t('Last update:', '마지막 업데이트:')}{' '}
        {formatDateToDayMonthYear(lastUpdated)}
      </div>
    </div>
  );
};

export default FaqHeader;
